import React from 'react';
import _ from 'underscore';

import ProductPage from '../../components/pages/product/[pid]/Index';
import Api from '../../helpers/api';
import { isBrowser } from '../../helpers/environment';
import Storage from '../../helpers/storage';
import Cart from '../../helpers/cart';
import { getCachedProducts, setCachedProducts } from '../../helpers/productsStore';
import {
  STORAGE_SETTINGS,
  STORAGE_NAVBAR,
  STORAGE_SLIDER,
  SITE_INFO_NAVBAR,
  SITE_INFO_SETTINGS,
  SITE_INFO_SLIDER,
} from '../../helpers/constants';
import { productProps, settingsProps } from '../../helpers/propTypes';

export default class ProductPageWrapper extends React.Component {
    static propTypes = {
      settings: settingsProps.isRequired,
      product: productProps.isRequired,
    }

    constructor(props) {
      super(props);
      const { settings, product } = this.props;
      if (isBrowser()) {
        Storage.set(STORAGE_SETTINGS, settings);
        if (!getCachedProducts()) {
          setCachedProducts([product]);
        }
      }
    }

    async componentDidMount() {
      const api = new Api();

      const [{ navbar, slider }, products] = await Promise.all([
        api.getSiteInfo([SITE_INFO_NAVBAR, SITE_INFO_SLIDER]),
        api.getProducts(),
      ]);

      Storage.set(STORAGE_NAVBAR, navbar);
      Storage.set(STORAGE_SLIDER, slider);
      setCachedProducts(products);
      Cart.actualizeProducts(products);
    }

    static getInitialProps = async ({ req, query }) => {
      if (isBrowser()) {
        const products = getCachedProducts();
        const settings = Storage.get(STORAGE_SETTINGS);

        const product = _.findWhere(products, { pos_id: Number(query.pid) });

        if (product && settings) {
          return { product, settings };
        }
      }

      const api = new Api({ domain: req ? req.headers.host : null });

      const [product, { settings }] = await Promise.all([
        api.getProduct(query.pid),
        api.getSiteInfo([SITE_INFO_SETTINGS]),
      ]);

      return { product, settings };
    }

    render() {
      return <ProductPage {...this.props} />;
    }
}
